<template>
  <div class="flex space-x-2.5">
    <v-text-field label="Buy Quantity" type="number" :value="buyQty" outlined dense hide-details
                  @input="buyQuantityChange" />
    <v-autocomplete label="Free Item Stock ID" :value="freeStockId" :items="stockOptions" item-value="id" outlined dense
                    :item-text="v => v.product_name + v.stock_code" hide-details @change="freeStockIdChange">
      <template v-slot:item="data">
        <div>
          <span class="font-semibold">{{ data.item.product_name }}</span>
          <span class="text-gray-500 ml-1">({{ data.item.stock_code }})</span>
        </div>
      </template>
      <template v-slot:selection="data">
        <span>{{ data.item.stock_code }}</span>
      </template>
    </v-autocomplete>
    <v-text-field label="Free Quantity" type="number" :value="getQty" outlined dense hide-details
                  @input="getQuantityChange" />
  </div>
</template>

<script>
import appAxios from '../../../../../extra-functions/axios.extra'
import { ErrorPopup } from '../../../../../lib/utils'

export default {
  name: 'CrossFreebie',
  props: {
    buyQty: {
      type: Number,
      default: 1,
    },
    freeStockId: {
      type: String, // allow string for v-autocomplete id
      default: null,
    },
    getQty: {
      type: Number,
      default: 1,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stockOptions: [],
    }
  },
  created() {
    this.getStockOptions()
  },
  methods: {
    async getStockOptions() {
      try {
        const { data: result } = await appAxios(this.$store.state.auth.token).get('/stocks/get-by-store')
        this.stockOptions = result.data
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error(e.message)
        }
        ErrorPopup.fire('Error', 'Failed to fetch stock options')
      }
    },
    /**
     * @param {InputEvent} e
     */
    buyQuantityChange(val) {
      this.$emit('update:buyQty', val ? Number(val) : 1)
    },
    /**
     * @param {Event} e
     */
    freeStockIdChange(val) {
      this.$emit('update:freeStockId', val ?? '')
    },
    /**
     * @param {InputEvent} e
     */
    getQuantityChange(val) {
      this.$emit('update:getQty', val ? Number(val) : 1)
    },
  },
}
</script>